export default "__VITE_ASSET__BDv7THug__"